(function () {
  'use strict';

  var MAX_VALUE_LENGTH = 100;
  var startedForms = typeof WeakSet === 'function' ? new WeakSet() : [];

  function isDebugMode() {
    try {
      return new URLSearchParams(window.location.search).get('ew_ga4_debug') === '1';
    } catch (error) {
      return false;
    }
  }

  function normalize(value, maxLength) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, maxLength || MAX_VALUE_LENGTH);
  }

  function slug(value) {
    return normalize(value, 80)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function pageType() {
    var path = window.location.pathname || '/';

    if (path === '/') return 'home';
    if (path.indexOf('/products/') === 0) return 'product';
    if (path.indexOf('/collections/') === 0) return 'collection';
    if (path.indexOf('/blogs/') === 0) return 'article';
    if (path.indexOf('/cart') === 0) return 'cart';
    if (path.indexOf('/search') === 0) return 'search';
    if (path.indexOf('/pages/') === 0) return 'page';

    return 'other';
  }

  function destinationPath(href) {
    if (!href) return '';
    if (/^tel:/i.test(href)) return 'phone';
    if (/^mailto:/i.test(href)) return 'email';

    try {
      var url = new URL(href, window.location.href);
      var destination = url.origin === window.location.origin
        ? url.pathname
        : url.hostname + url.pathname;

      if (url.hash && /^#ew[-_a-z0-9]+$/i.test(url.hash)) {
        destination += url.hash;
      }

      return normalize(destination, 160);
    } catch (error) {
      return normalize(href, 160);
    }
  }

  function journeyFor(path, label) {
    var value = (path + ' ' + label).toLowerCase();

    if (/class-finder|which-eat-well|choose-a-class/.test(value)) {
      return 'class_finder';
    }

    if (/private-baking-events|private-(sourdough|pasta|corporate|specialty|birthday|team|holiday)/.test(value)) {
      return 'private_events';
    }

    if (/hands-on-baking-classes|sourdough-bread-classes|hands-on-pasta-classes|gluten-free-baking|specialty-baking-classes|date-night-cooking|\/products\/.*class|cooking.*class|baking.*class|sourdough.*class|pasta.*class/.test(value)) {
      return 'classes';
    }

    if (/gift-card/.test(value)) return 'gift';

    if (/order-bakery-favorites|fresh-sourdough|\/products\/.*(bread|loaf|bagel|sourdough|donut|brownie|cookie|roll)/.test(value)) {
      return 'bakery';
    }

    if (/\/blogs\//.test(value)) return 'journal';

    if (/\/pages\/contact|tel:|mailto:/.test(value) || /\bcontact\b|\bcall\b/.test(label.toLowerCase())) {
      return 'contact';
    }

    return 'other';
  }

  function ctaSurface(element) {
    var ancestor = element.closest('header, nav, main, footer, form, section');
    if (!ancestor) return 'page';

    var signature = [
      ancestor.id || '',
      typeof ancestor.className === 'string' ? ancestor.className : '',
      ancestor.getAttribute('aria-label') || ''
    ].join(' ');

    if (/calendar/i.test(signature)) return 'calendar';
    if (/hero|welcome/i.test(signature)) return 'hero';
    if (/footer/i.test(signature) || ancestor.tagName.toLowerCase() === 'footer') return 'footer';
    if (ancestor.tagName.toLowerCase() === 'nav') return 'navigation';
    if (ancestor.tagName.toLowerCase() === 'header') return 'header';
    if (ancestor.tagName.toLowerCase() === 'form') return 'form';

    return 'content';
  }

  function sendEvent(eventName, parameters) {
    var payload = Object.assign({
      ew_page_type: pageType(),
      ew_source_path: normalize(window.location.pathname || '/', 160)
    }, parameters || {});

    if (isDebugMode()) {
      payload.debug_mode = true;
      payload.ew_qa_mode = true;
    }

    try {
      window.dataLayer = window.dataLayer || [];

      if (typeof window.gtag !== 'function') {
        window.gtag = function () {
          window.dataLayer.push(arguments);
        };
      }

      window.gtag('event', eventName, payload);
    } catch (error) {
      // Measurement must never interrupt navigation, checkout, or a form submission.
    }
  }

  function formType(form) {
    var signature = [
      form.id || '',
      typeof form.className === 'string' ? form.className : '',
      form.getAttribute('action') || ''
    ].join(' ').toLowerCase();

    if (/newsletter|ewnewsletter/.test(signature)) return 'newsletter';
    if (/ewcontact|contact-form|contact#/.test(signature)) return 'contact';

    return '';
  }

  function formFieldValue(form, fieldName) {
    var field = Array.prototype.find.call(form.elements, function (element) {
      return element.name === fieldName;
    });
    if (!field || typeof field.value !== 'string') return '';
    return slug(field.value);
  }

  function formParameters(form, type) {
    var parameters = {
      ew_form_type: type,
      ew_form_surface: ctaSurface(form),
      ew_form_action: destinationPath(form.getAttribute('action') || '')
    };

    if (type === 'contact') {
      parameters.ew_lead_topic = formFieldValue(form, 'contact[Topic]');
      parameters.ew_event_type = formFieldValue(form, 'contact[Private event direction]');
      parameters.ew_reply_method = formFieldValue(form, 'contact[Preferred reply method]');
    }

    return parameters;
  }

  function hasStarted(form) {
    if (startedForms instanceof WeakSet) return startedForms.has(form);
    return startedForms.indexOf(form) !== -1;
  }

  function setStarted(form) {
    if (startedForms instanceof WeakSet) {
      startedForms.add(form);
    } else if (startedForms.indexOf(form) === -1) {
      startedForms.push(form);
    }
  }

  document.addEventListener('focusin', function (event) {
    var form = event.target.closest ? event.target.closest('form') : null;
    if (!form || hasStarted(form)) return;
    if (event.target.type === 'submit' || event.target.type === 'button') return;

    var type = formType(form);
    if (!type) return;

    setStarted(form);
    sendEvent('ew_form_start', formParameters(form, type));
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    var type = formType(form);
    if (!type) return;

    var parameters = formParameters(form, type);
    sendEvent('ew_form_submit', parameters);

    if (type === 'contact') {
      sendEvent('generate_lead', parameters);
    }

    if (type === 'newsletter') {
      sendEvent('ew_newsletter_signup', parameters);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var element = event.target.closest ? event.target.closest('a, button') : null;
    if (!element || element.hasAttribute('data-ew-analytics-ignore')) return;

    var isSubmitControl = element.closest('form') && (
      element.type === 'submit' ||
      element.getAttribute('type') === 'submit'
    );
    if (isSubmitControl) return;

    var href = element.getAttribute('href') || '';
    var label = normalize(element.innerText || element.getAttribute('aria-label') || '', MAX_VALUE_LENGTH);
    var destination = destinationPath(href);
    var journey = journeyFor(destination, label);
    var classedCta = element.matches('.ew-btn, .ew-gold-btn, .ew-light-btn, .ew-paper-btn, .ew-co-btn, .ew-calendar-event, .ew-calendar-agenda-card');
    var highIntentLabel = /book|order|class|bread|bake|pasta|private|event|contact|call|gift|learn|explore|choose|calendar|join|subscribe/i.test(label);
    var trackable = /^tel:|^mailto:/i.test(href) || journey !== 'other' || classedCta || highIntentLabel;

    if (!trackable) return;

    sendEvent('ew_cta_click', {
      ew_journey: journey,
      ew_cta_type: /^tel:/i.test(href) ? 'phone' : (/^mailto:/i.test(href) ? 'email' : 'link'),
      ew_cta_label: label,
      ew_destination_path: destination,
      ew_cta_surface: ctaSurface(element)
    });
  }, true);
})();
